import React from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/system";
import { Grid, StyledEngineProvider, Typography } from "@mui/material";
import { theme } from "SosTheme.js";

import Header from "components/shared/Header.js";
import { ScrollToTop } from "components/ScrollToTop";
import { HeaderLinksLeft } from "HeaderLinks.js";
import { HeaderLinksRight } from "HeaderLinks.js";

import Home from "views/Home.js";
import ApiDoc from "views/ApiDoc/ApiDoc.js";
import { MyApps } from "views/MyApps/MyApps.js";

import PrivateRoute from "components/PrivateRoute";

export default function App() {
  return (
    <Router>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ScrollToTop />
          <CssBaseline />
          <AppHeader />
          <View />
          <AppFooter />
        </ThemeProvider>
      </StyledEngineProvider>
    </Router>
  );
}

function AppHeader() {
  return (
    <Header
      brand="SOS Inventory"
      brandLink="/home"
      leftLinks={<HeaderLinksLeft />}
      rightLinks={<HeaderLinksRight />}
    />
  );
}

function AppFooter() {
  const FooterPaper = styled(Typography)({
    borderTop: "1px solid #cccccc",
    fontFamily: "futura-pt, sans-serif",
    fontSize: "16px",
    color: "#666666",
    padding: "0.5em 5em",
    marginTop: "1.0em",
    "& a": {
      color: "#666666",
      textDecoration: "none",
      "&:hover": {
        color: "#333333",
        fontWeight: 400,
      },
    },
  });

  const GridTextRight = styled(Grid)({
    textAlign: "right",
  });

  return (
    <FooterPaper className="site-footer" component="div">
      <Grid container>
        <Grid item md={6} sm={12}>
          &copy; 2008-{new Date().getFullYear()} by SOS Inventory, LLC|
          support@sosinventory.com
        </Grid>
        <GridTextRight item md={6} sm={12}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.sosinventory.com/privacy-policy"
          >
            Privacy Policy
          </a>
          &nbsp;|&nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.sosinventory.com/terms-of-service"
          >
            Terms of Service
          </a>
        </GridTextRight>
      </Grid>
    </FooterPaper>
  );
}

function View() {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route exact path="/home">
        <Home />
      </Route>
      <Route path="/apidoc">
        <ApiDoc />
      </Route>
      <PrivateRoute exact path={"/myapps"} render={() => <MyApps />} />
      <Route>
        <Page404 />
      </Route>
    </Switch>
  );
}

function Page404(props) {
  return (
    <Grid container>
      <Grid item md={3} />
      <Grid item md={6}>
        <h1>Hmmmm.</h1>
        <p>
          Somehow, you tried to reach a page that doesn't exist at this web
          site. Try selecting from the menu items (Home, API Documentation,
          etc.) at the top of this page.
        </p>
      </Grid>
      <Grid item md={3} />
    </Grid>
  );
}
